/*
		table.js,

			Javascript controlled tables. For scrollable, and sortable tables.


		The initial implementation is not a dynamic table. For scrollable tables the table
		is embedded in an overflow: scroll div.
		Sorting is done by using an internal representation of the table data. When a sort based on a particular
		column is required the data is sorted internally, then all rows are removed from the table then readded
		in the correct order. Would an in place sort be better?

 */

var Event = require('./event.js');
var Class = require('./class.js');
var DOM = require('./dom.js');
var $ = require('./base.js').$;

var Table = module.exports = Class(null, {
	__init__: function(id, imgAsc, imgDesc, sortby, ascending, unsorted) {
		this.head = DOM.childByType($(id), "THEAD");
		this.body = DOM.childByType($(id), "TBODY");
		var headrows = DOM.childrenByType(this.head, "TR");
		this.headrow = headrows[headrows.length - 1];		/* pick the *last* <tr> */
		this.imgAsc = DOM.style({'marginLeft': '10px', 'verticalAlign': 'middle'}, DOM.IMG({'src': imgAsc || 'sort_asc.gif'}));
		this.imgDesc = DOM.style({'marginLeft': '10px', 'verticalAlign': 'middle'}, DOM.IMG({'src': imgDesc || 'sort_desc.gif'}));
		this.ascOwner = null;
		this.descOwner = null;
		if (unsorted == null)
			this.unsorted = [];
		else
			this.unsorted = unsorted;

		if(sortby != null)
			this.sortBy = sortby;
		else
			this.sortBy = 0;
		if(ascending != null)
			this.ascending = ascending;
		else
			this.ascending = true;
		this.data = [];
		this.setArrow();
	},

	setArrow: function(oldidx, oldasc, idx, asc) {
		if(this.ascOwner)
			this.ascOwner.removeChild(this.imgAsc);
		if(this.descOwner)
			this.descOwner.removeChild(this.imgDesc);
		this.ascOwner = null;
		this.descOwner = null;
		var owner = DOM.childrenByType(this.headrow, 'TH')[this.sortBy];
		if(this.ascending) {
			owner.appendChild(this.imgAsc);
			this.ascOwner = owner;
		}
		else {
			owner.appendChild(this.imgDesc);
			this.descOwner = owner;
		}
	},

	addRow: function(row, tr) {
		if(! tr) {
			/* for simpler tables we can create the tr */
			tr = DOM.TR();
			var val;
			for(var i = 0; i < row.length; i++) {
				val = row[i];
				if(val == null || val == undefined)
					val = '';
				val = val.toString();
				DOM.addNodes(tr, DOM.TD(null, val));
			}
		}
		this.data.push([row, tr]);
	},

	sorter: function(rowidx) {
		return function() {
			if(rowidx == this.sortBy)
				this.ascending = ! this.ascending;
			else
				this.ascending = true;
			this.sortBy = rowidx;
			this.setArrow();
			this.populate();
		};
	},

	sort: function() {
		var neg = -1, pos = 1;
		if(! this.ascending) {
			neg = 1;
			pos = -1;
		}
		var idx = this.sortBy;
		var icase = function(a, b) {
			a = a[0][idx];
			b = b[0][idx];
			if(typeof a === 'string' && typeof b === 'string') {
				// perform case insensitive compare
				a = a.toLowerCase();
				b = b.toLowerCase();
			}
			if(a < b)
				return neg;
			if(a > b)
				return pos;
			return 0;
		};

//		this.data = this.data.sort(function(a, b) { if(a[0][idx] < b[0][idx]) return neg; else if(a[0][idx] > b[0][idx]) return pos; return 0; });
		this.data = this.data.sort(icase);
	},

	linkHeaders: function() {
		var headers = DOM.childrenByType(this.headrow, "TH");
		for(var i = 0; i < headers.length; i++) {
			/* make all th's links to sort by that column */
			var th = headers[i];

			if(this.unsorted.indexOf(i) == -1){
				th.style.cursor = 'pointer';
				Event.observe(th, 'click', this, this.sorter(i));
			}
		}
	},

	populate: function() {
		this.sort();
		this.clear();
		for(var i = 0; i < this.data.length; i++)
			this.body.appendChild(this.data[i][1]);
	},

	clear: function() {
		while(this.body.firstChild)
			this.body.removeChild(this.body.firstChild);
	}
});

